module.exports = __webpack_public_path__ + "static/media/pic_default_live.809a0625.png";